import $api from "@/api/index";
import { SnapshotDay, SnapshotTimestampsResponse } from "@/types/snapshots";

export async function getSnapshotTimestamps(
  day: SnapshotDay
): Promise<SnapshotTimestampsResponse> {
  const response = await $api.get<{ data: SnapshotTimestampsResponse }>(
    "/v2/snapshots/hexagons/timestamps",
    {
      params: { day },
    }
  );

  return response.data.data;
}
